import "./assets/styles/reset.scss";
import "./assets/styles/global.scss";

import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./i18n";
import { Provider } from "react-redux";
import { setupStore } from "./store/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const store = setupStore();
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </Provider>
);
